import React from "react";


const DataMapping = React.createContext(['', () => { }]);

export default DataMapping;